import { call, put, all, takeEvery } from 'redux-saga/effects';
import * as Actions from '../../actions';
import rolesService from 'app/services/rolesService';
import { showToast } from 'app/store/actions/fuse';

function* createRolePolicy(action) {
	try {
		const response = yield call(() => rolesService.createRolePolicy(action.payload));
		yield put(Actions.createRolePolicySuccess(response.data));
		yield put(showToast.success('Role updated'));
	} catch (error) {
		yield put(Actions.createRolePolicyFailure());
		yield put(showToast.error('Unable to save the role policy: ' + error));
	}
}

function* updateRolePolicy(action) {
	const rolePolicy = {
		id: action.payload.policyId,
		operationId: action.payload.operationId,
		contextId: action.payload.contextId,
		roleId: action.payload.roleId
	};
	try {
		const response = yield call(() => rolesService.updateRolePolicy(rolePolicy));
		yield put(Actions.updateRolePolicySuccess(response.data));
		yield put(showToast.success('Role updated'));
	} catch (error) {
		yield put(Actions.updateRolePolicyFailure());
		yield put(showToast.error('Unable to update the role policy: ' + error));
	}
}

function* deleteRolePolicy(action) {
	const rolePolicy = {
		id: action.payload.policyId,
		operationId: action.payload.operationId,
		contextId: action.payload.contextId,
		roleId: action.payload.roleId
	};
	try {
		const response = yield call(() => rolesService.deleteRolePolicy(rolePolicy));
		yield put(Actions.deleteRolePolicySuccess(response.data));
		yield put(showToast.success('Role updated'));
	} catch (error) {
		yield put(Actions.deleteRolePolicyFailure());
		yield put(showToast.error('Unable to update the role policy: ' + error));
	}
}

function* watchRolePolicy() {
	yield all([
		takeEvery(Actions.createRolePolicy, createRolePolicy),
		takeEvery(Actions.updateRolePolicy, updateRolePolicy),
		takeEvery(Actions.deleteRolePolicy, deleteRolePolicy)
	]);
}

export default watchRolePolicy;
